export enum LocalFirstVisitCase {
  clearedIoNotifications = 'clearedIoNotifications',
  notificationPrompt = 'notificationPrompt',
  reminders = 'reminders',
}
